import { useState } from 'react';
import { StyledVoiceoverPlayback } from './VoiceoverPlayback.styled';
import { SelectableButton } from '../';
import { theme } from '../../theme';

const DIAGRAM_ITEMS = 128; 
const FrequencyDiagram = ({ frequencyData = [], progress = 0 }) => {
  const itemWidth = 100 / frequencyData.length || 1;

  const firstWhiteIndex = Math.floor(progress * DIAGRAM_ITEMS); 
  return (
    <div className='voiceover-freq-diagram'>
      {frequencyData.map((d, ind) => (<div style={{ background: ind >= firstWhiteIndex ? 'white' : theme.selection, width: `${itemWidth}%`, height: `${d > 5 ? d : 2}%`}} />))}
    </div>
  );
}

const convertFrequencyDataIntoDiagram = (frequencyData) => {
  let data = [...frequencyData];
  const reducingFactor = Math.ceil(data.length / DIAGRAM_ITEMS);
  if (reducingFactor > 1) {
    data = data.filter((_, i) => !((i + 1) % reducingFactor));
  }
  return data.map((d) => Math.ceil(d / 255 * 100));
};

const VoiceoverPlayback = ({ lipsync = null, duration = '-- : --', disabled = false, isPlaying = false, onClickPlay = () => {}, onClickDownload = () => {} }) => {
  const [frequencyData, setFrequencyData] = useState(new Array(DIAGRAM_ITEMS).fill(0));
  const [progress, setProgress] = useState(0);
  const freqDataToShow = isPlaying ? frequencyData : new Array(DIAGRAM_ITEMS).fill(0);

  if (lipsync) {
    lipsync.onUpdate = (freqData, progress) => {
      setFrequencyData(convertFrequencyDataIntoDiagram(freqData));
      setProgress(progress);
    };
  }
  
  return (
    <StyledVoiceoverPlayback $disabled={disabled}>
      <div className='voiceover-playback-content-wrapper'>
        <div className='voiceover-playback-content'>
          <div className='voiceover-playback-controls'>
	    <SelectableButton
              disabled={disabled}
              selected={false}
              isIconButton={true}
	      backgroundOverwrite={theme.selectorHover}
	      borderOverwrite='rgba(0, 0, 0, .16)'
              onClick={() => disabled ? true : onClickPlay()}
              img={isPlaying ? '/assets/pause.svg' : '/assets/play.svg'} />
            <FrequencyDiagram frequencyData={freqDataToShow} progress={isPlaying ? progress : 0}/>
            <div className='voiceover-playback-duration'>{duration}</div>
	    <SelectableButton
              disabled={disabled}
              selected={false}
              isIconButton={true}
	      backgroundOverwrite={theme.buttonBrightBlue}
	      borderOverwrite='rgba(0, 0, 0, .16)'
              onClick={() => disabled ? true : onClickDownload()}
              img='/assets/download.svg' />
          </div>
        </div>
      </div>
      <div className='voiceover-playback-corner voiceover-playback-corner-top' />
      <div className='voiceover-playback-corner voiceover-playback-corner-tl' />
      <div className='voiceover-playback-corner voiceover-playback-corner-tr' />
      <div className='voiceover-playback-corner voiceover-playback-corner-bl' />
      <div className='voiceover-playback-corner voiceover-playback-corner-br' />
    </StyledVoiceoverPlayback>
  )
};

export default VoiceoverPlayback;
